"use client";

import { Dispatch, SetStateAction } from "react";
import Tabs from "@/components/ui/Tabs";
import { INITIAL_PART_NAME } from "@/const/initialPartStyle";
import PartList from "./PartList";
import PartMenu from "./PartMenu";
import styles from "./PartSelect.module.scss";

type Props = {
	setShowPalette: Dispatch<SetStateAction<boolean>>;
	setShowPartMove: Dispatch<SetStateAction<boolean>>;
	showPalette: Boolean;
	showPartMove: Boolean;
};

/**
 * パーツを選択する コンポーネント
 * @returns {JSX.Element} パーツを選択する コンポーネント
 */
export default function PartSelect(props: Props) {
	const { setShowPalette, setShowPartMove, showPartMove } = props;

	return (
		<div className={styles.partSelectContainer}>
			<Tabs
				defaultValue={INITIAL_PART_NAME}
				TriggerComponent={
					<PartMenu
						setShowPalette={setShowPalette}
						setShowPartMove={setShowPartMove}
					/>
				}
				ContentComponent={<PartList showPartMove={showPartMove} />}
			></Tabs>
		</div>
	);
}
